import { Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { NotificationsProvider } from './contexts/NotificationsContextType';
import { DocumentsProvider } from './contexts/DocumentsContext';
import './App.css';

// Layouts et routes
import MainLayout from './Layout/MainLayout';
import PrivateRoute from './composants/PrivateRoute/PrivateRoute';

// Pages publiques
import Accueil from './pages/Accueil/Accueil';
import Login from './pages/Login/Login';
import Register from './pages/Register/Register';
import ForgotPassword from './pages/ForgotPassword/ForgotPassword';
import Securite from './pages/Securite/Securite';
import MentionsLegales from './pages/MentionsLegales/MentionsLegales';
import CharteRSE from './pages/CharteRSE/CharteRSE';
import CharteDeontologie from './pages/CharteDeontologie/CharteDeontologie';
import CharteAchatsDurables from './pages/CharteAchatsDurables/CharteAchatsDurables';

// Pages privees
import Commandes from './pages/Commandes/Commandes';
import SuiviDeCommande from './pages/SuiviDeCommande/SuiviDeCommande';
import SuiviOperation from './pages/SuiviOperation/SuiviOperation';
import SuiviOperationBC from './pages/SuiviOperationBC/SuiviOperationBC';
import SuiviOperationBCI from './pages/SuiviOperationBCI/SuiviOperationBCI';
import SuiviDeCommandesBC from './pages/SuiviDeCommandeBC/SuiviDeCommandeBC';
import SuiviDeCommandesBCI from './pages/SuiviDeCommandeBCI/SuiviDeCommandeBCI';
import Operation from './pages/Operation/Operation';
import Annuaire from './pages/Annuaire/Annuaire';
import FicheContact from './pages/FicheContact/FicheContact';
// FRONT-05: Page Profil unifiee avec routage intelligent
import ProfilRouter from './pages/Profil/ProfilRouter';
import Assistance from './pages/Assistance/Assistance';
import Mentions from './pages/Mentions/Mentions';
import Publications from './pages/Publications/Publications';
import DetailCandidature from './pages/Publications/components/DetailCandidature/DetailCandidature';
import Documents from './pages/Documents/Documents';
import VerifyEmail from './pages/VerifyEmail/VerifyEmail';
import VerifyEmailSend from './pages/VerifyEmailSend/VerifyEmailSend';
import CG from './pages/CG/CG';
import { Verify } from 'crypto';
import ResetPassword from './pages/ResetPassword/ResetPassword';
import CommandesArchive from './pages/CommandesArchive/CommandesArchive';
import TicketPage from './pages/Ticket/Ticket';

function App() {
  return (
    <AuthProvider>
      <DocumentsProvider>
        <NotificationsProvider>
          <div className="App">
            <main className="content">
              <Routes>

                {/* --- Routes publiques --- */}
                <Route path="/cgv" element={<CG />} />
                <Route path="/documents-mobile" element={<Documents />} />
                <Route path="/verify-email" element={<VerifyEmail />} />
                <Route path="/verify-email-send" element={<VerifyEmailSend />} />
                <Route path='/reset-password' element={<ResetPassword />} />


                <Route element={<MainLayout />}>
                  <Route path="/" element={<Accueil />} />
                  <Route path="/securite" element={<Securite />} />
                  <Route path="/mentions-legales" element={<MentionsLegales />} />
                  <Route path="/charte-rse" element={<CharteRSE />} />
                  <Route path="/charte-deontologie" element={<CharteDeontologie />} />
                  <Route path="/charte-achats" element={<CharteAchatsDurables />} />
                  <Route path="/assistance" element={<Assistance />} />
                  <Route path="/mentions" element={<Mentions />} />
                  <Route path="/annuaire" element={<Annuaire />} />
                  <Route path="/login" element={<Login />} />
                  <Route path="/register" element={<Register />} />
                  <Route path="/forgot-password" element={<ForgotPassword />} />


                  {/* --- Routes protégées --- */}
                  <Route element={<PrivateRoute />}>

                    <Route path="/commandes" element={<Commandes />} />
                    <Route path="/commande-ms/:id" element={<SuiviDeCommande />} />
                    <Route path="/operations" element={<Operation />} />
                    <Route path="/operation-ms/:id" element={<SuiviOperation />} />
                    <Route path="operation-bc/:id" element={<SuiviOperationBC />} />
                    <Route path="commande-bc/:id" element={<SuiviDeCommandesBC />} />
                    <Route path="commande-bci/:id" element={<SuiviDeCommandesBCI />} />
                    <Route path="operation-bci/:id" element={<SuiviOperationBCI />} />
                    {/* <Route path="/commandes-archive" element={<CommandesArchive />} /> */}
                    <Route path="/contact/:id" element={<FicheContact />} />
                    {/* FRONT-05: Page Profil avec routage intelligent selon le role */}
                    <Route path="/profil" element={<ProfilRouter />} />
                    {/* Redirect ancien URL pour compatibilite */}
                    <Route path="/profil-prestataire" element={<Navigate to="/profil" replace />} />
                    <Route path="/publications" element={<Publications />} />
                    {/* Story 9.0 — L'ancienne page DashboardCandidatures est remplacée par l'onglet "Mes candidatures" */}
                    <Route path="/publications/ac27" element={<Navigate to="/publications?tab=mes-candidatures" replace />} />
                    <Route path="/publications/ac27/candidatures/:id" element={<DetailCandidature />} />
                    <Route path="/ticket/:id" element={<TicketPage />} />
                  </Route>
                </Route>

              </Routes>
            </main>
          </div>
        </NotificationsProvider>
      </DocumentsProvider>
    </AuthProvider>
  );
}

export default App;